module.exports = __webpack_public_path__ + "img/upload-success.7314f62c.png";